<div class="card">
    <div class="card-body">
        <surge-table [delegate]="this" name="suppliers"></surge-table>
        @if (saved || error) {
            <div>
                <hr />
                @if (saved) {
                    <surge-alert
                        type="success"
                        messages="Everything was sent."
                        (onDismiss)="saved = false"
                    ></surge-alert>
                }
                @if (error) {
                    <surge-alert type="danger" [messages]="error" (onDismiss)="error = null"></surge-alert>
                }
            </div>
        }
        <hr />

        <surge-data-import
            [importTemplateEndpoint]="importTemplateUrl"
            [importTemplateFilename]="'Handbook_Supplier_Template.xlsx'"
            [additionalData]="{ prefix: 'Supplier' }"
            [url]="importUrl"
            (failed)="importFailed($event)"
            (done)="afterImport($event)"
            (start)="beforeImport()"
        >
            <div class="text-right">
                <button surgeButton type="submit" (click)="addNewItem()">Add new item</button>
                <button surgeButton (click)="save()" [disabled]="!canSave()" [busy]="saving">Save</button>
            </div>
        </surge-data-import>
    </div>
</div>
